import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '../assets/images/logo_IM.png'
import _imports_1 from '../assets/images/logo_customer.png'


const _hoisted_1 = { class: "header" }
const _hoisted_2 = { class: "left-header" }
const _hoisted_3 = {
  key: 0,
  style: {"padding-top":"12px","width":"150px","float":"left"}
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  width: "150",
  style: {"margin-left":"20px"},
  alt: "",
  srcset: ""
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  style: {"padding-top":"12px","width":"150px","float":"left"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  width: "150",
  style: {"margin-left":"20px"},
  alt: "",
  srcset: ""
}, null, -1 /* HOISTED */)
const _hoisted_8 = [
  _hoisted_7
]
const _hoisted_9 = { class: "right-header" }
const _hoisted_10 = { class: "el-dropdown-link" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_menu_item = _resolveComponent("el-menu-item")!
  const _component_el_menu = _resolveComponent("el-menu")!
  const _component_arrow_down = _resolveComponent("arrow-down")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_lock = _resolveComponent("lock")!
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.isAdmin)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [..._hoisted_5]))
        : (_openBlock(), _createElementBlock("div", _hoisted_6, [..._hoisted_8])),
      _createVNode(_component_el_menu, {
        "default-active": _ctx.activeMenu,
        class: "el-menu",
        mode: "horizontal",
        style: {"margin-left":"227px"},
        "background-color": "#4B6FFF",
        "text-color": "#fff",
        "active-text-color": "#fff",
        router: ""
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.menus, (menu) => {
            return (_openBlock(), _createBlock(_component_el_menu_item, {
              key: menu.path,
              index: menu.path
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(menu.text), 1 /* TEXT */)
              ]),
              _: 2 /* DYNAMIC */
            }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["index"]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 1 /* STABLE */
      }, 8 /* PROPS */, ["default-active"])
    ]),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_el_dropdown, { trigger: "click" }, {
        dropdown: _withCtx(() => [
          _createVNode(_component_el_dropdown_menu, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_dropdown_item, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.modifyPassword()))
              }, {
                prefix: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "l-icon--left" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_lock)
                    ]),
                    _: 1 /* STABLE */
                  })
                ]),
                default: _withCtx(() => [
                  _createTextVNode("修改密码 ")
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_el_dropdown_item, {
                icon: _ctx.User,
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.personal()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("个人资料")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["icon"]),
              _createVNode(_component_el_dropdown_item, {
                icon: _ctx.Plus,
                divided: "",
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.logOut()))
              }, {
                default: _withCtx(() => [
                  _createTextVNode("退出登录 ")
                ]),
                _: 1 /* STABLE */
              }, 8 /* PROPS */, ["icon"])
            ]),
            _: 1 /* STABLE */
          })
        ]),
        default: _withCtx(() => [
          _createElementVNode("span", _hoisted_10, [
            _createTextVNode(_toDisplayString(_ctx.account) + " ", 1 /* TEXT */),
            _createVNode(_component_el_icon, { class: "el-icon--right" }, {
              default: _withCtx(() => [
                _createVNode(_component_arrow_down)
              ]),
              _: 1 /* STABLE */
            })
          ])
        ]),
        _: 1 /* STABLE */
      })
    ])
  ]))
}